import React from 'react';
import { Typography, Space } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { PanelTokenManager } from '@/features/panel-tokens/components/PanelTokenManager';
import { useResponsive } from '@/shared/hooks/useResponsive';

const { Title } = Typography;

/**
 * 設定ページ
 * 盤認証トークンなどのシステム設定を管理
 */
export const SettingsPage: React.FC = () => {
  const { isMobile } = useResponsive();

  return (
    <div>
      <div className={isMobile ? 'mb-4' : 'mb-6'}>
        <Title level={2}>
          <Space>
            <SettingOutlined />
            設定
          </Space>
        </Title>
      </div>

      <PanelTokenManager />
    </div>
  );
};
